// 9fbef606107a605d69c0edbcd8029e5de
import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import Modal from '@tcp/core/src/components/common/molecules/Modal';
import { getIconPath, getAPIConfig, isCanada } from '@tcp/core/src/utils/utils';
import { getPLPProductAttributes } from '@tcp/core/src/utils/badge.util';
import Image from '@tcp/core/src/components/common/atoms/Image';
import DamImage from '@tcp/core/src/components/common/atoms/DamImage';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import { PLPLabels } from '@tcp/core/src/utils/labels/browse/PLP.labels';
import Price from '@tcp/core/src/components/features/browse/BundleProduct/atoms/Price';
import { routerPush } from '@tcp/core/src/utils';
import collectSimilarProductData from '../SimilarProductsHelper';
import SortWrapper from '../../../../features/browse/CategoryListingPage/molecules/SortWrapper/views/SortWrapper.view';
import { getPdpUrl } from '../../../../features/browse/PlpTile/views/plpTileHelpers/plpTileCommonHelpers';
import drawerModalStyles from '../styles/SimilarProductsModal.style';
import { modalStyles } from '../../QuickViewModal/styles/QuickViewModalModalAnimation.style';
import {
  pdpLabels,
  PdpSub,
} from '../../../../features/browse/ProductDetail/views/ProductDetail.labels';
import { getLocator } from '../../../../../utils';
import {
  getDynamicLabelValues,
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../utils/labels/labelUtilty';

const getMerchantTag = (listOfAttributes = '') => {
  const attributesMap = {};

  if (!isEmpty(listOfAttributes)) {
    listOfAttributes.split(';').forEach((attr) => {
      const [key, value] = attr.split(':');
      if (key && value) {
        attributesMap[key] = value;
      }
    });
  }

  const plpAttrs = getPLPProductAttributes();
  const merchantKey = plpAttrs.merchant;

  return attributesMap[merchantKey] || '';
};

class SimilarProductsModal extends React.PureComponent {
  state = {
    sortedProducts: this.props.similarProducts,
  };

  // eslint-disable-next-line sonarjs/cognitive-complexity
  handleSortChange = (sortSelected) => {
    const { similarProducts } = this.props;
    let sortedProducts = [...similarProducts];

    switch (sortSelected) {
      case 'min_offer_price asc':
        sortedProducts.sort(
          (a, b) =>
            (a.TCPCustomSalePrice || a.min_offer_price) -
            (b.TCPCustomSalePrice || b.min_offer_price)
        );
        break;
      case 'min_offer_price desc':
        sortedProducts.sort(
          (a, b) =>
            (b.TCPCustomSalePrice || b.min_offer_price) -
            (a.TCPCustomSalePrice || a.min_offer_price)
        );
        break;
      case 'favoritedcount desc':
        sortedProducts.sort((a, b) => b.favoritedcount - a.favoritedcount);
        break;
      case 'TCPBazaarVoiceRating desc':
        sortedProducts.sort((a, b) => b.TCPBazaarVoiceRating - a.TCPBazaarVoiceRating);
        break;
      case 'newest_score desc':
        sortedProducts.sort((a, b) => {
          const TCPProductInd = isCanada() ? 'TCPProductIndCanadaStore' : 'TCPProductIndUSStore';
          const aIsNew = a[TCPProductInd] === 'New Arrivals';
          const bIsNew = b[TCPProductInd] === 'New Arrivals';

          if (aIsNew && !bIsNew) return -1;
          if (!aIsNew && bIsNew) return 1;
          return 0;
        });
        break;
      default:
        sortedProducts = [...similarProducts];
    }

    this.setState({ sortedProducts });
  };

  handleProductClick = (product) => {
    const { getImageUrl, getBrandVal, saveProductDataForPdp } = this.props;
    const apiConfig = getAPIConfig();
    const { siteId } = apiConfig;
    const {
      productid: productPartNo,
      TCPPrimaryCategoryCanadaStore,
      TCPPrimaryCategoryUSStore,
      seo_token: seoToken,
    } = product;
    const TCPPrimaryCategory = isCanada()
      ? TCPPrimaryCategoryCanadaStore
      : TCPPrimaryCategoryUSStore;
    const productData = collectSimilarProductData({
      product,
      imageUrl: getImageUrl(product.productid, product.productimage),
      primaryBrand: getBrandVal(product.TCPPrimaryBrandUSStore, product.TCPPrimaryBrandCanadaStore),
      apiConfig,
      TCPPrimaryCategory,
    });

    saveProductDataForPdp(productData);

    const { pdpUrl } = getPdpUrl({
      seoToken,
      siteId,
      productPartNo,
      isBundleProduct: false,
      TCPPrimaryCategory,
    });
    routerPush(pdpUrl.href, pdpUrl.asPathWithoutSlug);
  };

  render() {
    const { sortedProducts } = this.state;
    const {
      isOpen,
      onRequestClose,
      similarProducts,
      className,
      handleAddToBagClick,
      name,
      departmentName,
      TCPColor,
      productId,
      pdpImage,
      getImageUrl,
      getBrandVal,
      onAfterClose,
    } = this.props;

    const PDPLabels = getLabelFromCopyOrFromTranslation(PdpSub, pdpLabels);
    const colorlabel = getLabelFromCopyOrFromTranslation(
      'PLP.PLP_sort_filter.lbl_color',
      PLPLabels
    );

    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={onRequestClose}
        onAfterClose={onAfterClose}
        className={`TCPModal__Content, ${className}`}
        inheritedStyles={modalStyles}
        innerContentClassName="atb-innerContent"
        overlayClassName="TCPModal__Overlay"
        dataLocator="similar_products_modal"
        dataLocatorHeader={getLocator('similar_product_modal_header')}
        closeIconDataLocator="similar_products_modal_close_icon"
        heading={`${renderLabel(
          getDynamicLabelValues('dynamic.browse_d.lbl_modalOffer_detail_heading_text'),
          'lbl_modalOffer_detail_heading_text'
        )}`}
        headingAlign="center"
        headingFontWeight="bold"
        fontSize="fs22"
        headingFontFamily="secondary"
      >
        <div
          className="similar-products-container"
          aria-modal="true"
          aria-label="Similar Products Modal"
        >
          <div>
            {similarProducts && similarProducts.length > 0 && (
              <div className="product-details-pdp">
                <div className="product-image-pdp">
                  <DamImage
                    imgData={{
                      alt: name || `Product ${productId}`,
                      url: getImageUrl(productId, pdpImage) || '',
                    }}
                    isProductImage
                    lazyLoadImage
                  />
                </div>
                <div className="details">
                  <p>{name}</p>
                  <div className="pdp-details">
                    {departmentName && (
                      <div className="pdp-line">
                        <span className="label">
                          {renderLabel(PDPLabels.lbl_department, 'lbl_department')}:
                        </span>
                        <span className="value">{departmentName}</span>
                      </div>
                    )}
                    {TCPColor && (
                      <div className="pdp-line">
                        <span className="label">{colorlabel}:</span>
                        <span className="value">{TCPColor}</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
          <hr className="horizontal-line" />
          <div className="count-sort-products">
            <div className="products-count">{sortedProducts.length} items</div>
            <div className="sort-wrapper">
              <SortWrapper
                submitSortChange={this.handleSortChange}
                totalProductsCount={sortedProducts.length}
                isPlp={false}
                pathName=""
              />
            </div>
          </div>
          {sortedProducts && sortedProducts.length > 0 && (
            <div className="similar-products-grid">
              {sortedProducts.map((product, index) => {
                const minListPrice = product.TCPCustomListPrice || product.min_list_price;
                const minOfferPrice = product.TCPCustomSalePrice || product.min_offer_price;
                const brand = getBrandVal(
                  product.TCPPrimaryBrandUSStore,
                  product.TCPPrimaryBrandCanadaStore
                );
                return (
                  <div key={product.uniqueId || index} className="product-tile">
                    <div className="product-card">
                      <button
                        className="product-image-wrapper"
                        onClick={() => {
                          this.handleProductClick(product);
                          onRequestClose();
                        }}
                      >
                        <DamImage
                          imgData={{
                            alt: product.product_name || `Product ${product.uniqueId || index}`,
                            url: getImageUrl(product.productid, product.productimage) || '',
                          }}
                          className="product-image"
                          isProductImage
                          lazyLoadImage
                          primaryBrand={brand}
                        />
                      </button>
                      <div className="product-details">
                        <div className="similar-modal-product-price">
                          <Price
                            minListPrice={minListPrice}
                            minOfferPrice={minOfferPrice}
                            lowOfferPrice={product.low_offer_price}
                            highOfferPrice={product.high_offer_price}
                            lowListPrice={product.low_list_price}
                            highListPrice={product.high_list_price}
                            productPartNo={product.prodpartno}
                            merchantTag={getMerchantTag(product.list_of_attributes)}
                            primaryBrand={product.primaryBrand}
                          />
                        </div>
                        <button
                          className="add-to-bag-icon"
                          onClick={() =>
                            handleAddToBagClick(product.uniqueId, 'SimilarProductsModal')
                          }
                          aria-label="Add Similar Products to bag"
                        >
                          <Image
                            className="atb-icon-image"
                            src={getIconPath('add-to-bag-icon-blue')}
                            aria-hidden={true}
                            alt="Add to bag Icon"
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </Modal>
    );
  }
}

SimilarProductsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  similarProducts: PropTypes.arrayOf(
    PropTypes.shape({
      uniqueId: PropTypes.string,
      product_name: PropTypes.string,
      unbxd_imageUrl: PropTypes.string,
      offerPrice: PropTypes.number,
      listPrice: PropTypes.number,
    })
  ).isRequired,
  className: PropTypes.string,
  handleAddToBagClick: PropTypes.func.isRequired,
  name: PropTypes.string,
  departmentName: PropTypes.string,
  TCPColor: PropTypes.string,
  productId: PropTypes.string,
  brand: PropTypes.string,
  pdpImage: PropTypes.string,
};

SimilarProductsModal.defaultProps = {
  className: '',
};

export default withStyles(SimilarProductsModal, drawerModalStyles);
